(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cp-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cp-description')) {
    customElements.define(
      'cp-description',
      class extends HTMLElement {
        connectedCallback() {
          const body = this.querySelector('.cp-description__body');
          const toggle = this.querySelector('.cp-description__toggle');
          if (!body || !toggle) return;
          // Only clip when the text is clearly longer than the collapsed height.
          const limit = parseFloat(getComputedStyle(this).getPropertyValue('--cp-description-height')) || 180;
          if (body.scrollHeight <= limit + 40) {
            this.classList.add('is-short');
            return;
          }
          toggle.hidden = false;
          toggle.addEventListener('click', () => {
            const open = this.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', String(open));
            if (!open) this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cp-postbuy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cp-delivery-estimate')) {
    const addBusinessDays = (from, days) => {
      const date = new Date(from);
      let left = days;
      while (left > 0) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (day !== 0 && day !== 6) left -= 1;
      }
      return date;
    };
    const short = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
    const long = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

    customElements.define(
      'cp-delivery-estimate',
      class extends HTMLElement {
        connectedCallback() {
          const today = new Date();
          const min = Number(this.dataset.min);
          const max = Number(this.dataset.max);
          const minEl = this.querySelector('[data-date-min]');
          const maxEl = this.querySelector('[data-date-max]');
          if (minEl) minEl.textContent = long.format(addBusinessDays(today, min));
          if (maxEl) maxEl.textContent = long.format(addBusinessDays(today, max));
          this.querySelectorAll('li[data-days]').forEach((step) => {
            const target = step.querySelector('[data-step-date]');
            if (!target) return;
            const start = short.format(addBusinessDays(today, Number(step.dataset.days)));
            const end = step.dataset.daysTo ? short.format(addBusinessDays(today, Number(step.dataset.daysTo))) : '';
            target.textContent = end && end !== start ? `${start} – ${end}` : start;
          });
        }
      }
    );
  }

  if (!customElements.get('cp-copy-code')) {
    customElements.define(
      'cp-copy-code',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.copy);
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.copy();
            }
          });
        }

        copy = () => {
          navigator.clipboard?.writeText(this.dataset.code).then(() => {
            this.classList.add('is-copied');
            setTimeout(() => this.classList.remove('is-copied'), 1600);
          });
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
